import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    if (localStorage.getItem('access_token')) {
      this.router.navigate(['/chat']);
    } else {
      this.router.navigate(['/auth/login']);
    }
    return true; // On bloque l'accès direct à `/`, on redirige
  }
}
